import {
  RESTAURANT_FREE_PLAN_BENEFIT_IDS,
  RESTAURANT_PRO_PLAN_BENEFIT_IDS,
  RESTAURANT_SUBSCRIPTION_PRICING_BENEFIT_IDS,
  type RestaurantSubscriptionPricingBenefitId,
} from "@menuhunter/core/restaurantSubscriptionBenefits";
import type { Translations } from "@/lib/translations";

export type RestaurantPricingFeatures = Translations["restaurantsPage"]["pricing"]["plans"]["free"]["features"];
export type RestaurantProPricingFeatures = Translations["restaurantsPage"]["pricing"]["plans"]["pro"]["features"];

/** Free plan benefit lines for marketing cards. */
export function getRestaurantFreePricingFeatureLines(features: RestaurantPricingFeatures): string[] {
  return RESTAURANT_FREE_PLAN_BENEFIT_IDS.map((id) => features[id]);
}

/** Pro plan benefit lines for marketing cards. */
export function getRestaurantProPricingFeatureLines(features: RestaurantProPricingFeatures): string[] {
  return RESTAURANT_PRO_PLAN_BENEFIT_IDS.map((id) => features[id]);
}

/** Legacy combined list (homepage preview subset). */
export function getRestaurantPricingFeatureLines(
  features: Record<RestaurantSubscriptionPricingBenefitId, string>
): string[] {
  return RESTAURANT_SUBSCRIPTION_PRICING_BENEFIT_IDS.map((id) => features[id]);
}

/** Homepage restaurant preview — subset of pricing benefits (single source of copy). */
export const HOME_RESTAURANT_PREVIEW_BENEFIT_IDS = [
  "discovery",
  "updateDaily",
  "qrCode",
  "photos",
  "verified",
  "noCommission",
] as const satisfies readonly RestaurantSubscriptionPricingBenefitId[];

export function getHomeRestaurantPreviewFeatures(
  features: Record<RestaurantSubscriptionPricingBenefitId, string>
): string[] {
  return HOME_RESTAURANT_PREVIEW_BENEFIT_IDS.map((id) => features[id]);
}

export {
  RESTAURANT_SUBSCRIPTION_PRICING_BENEFIT_IDS,
  RESTAURANT_FREE_PLAN_BENEFIT_IDS,
  RESTAURANT_PRO_PLAN_BENEFIT_IDS,
  type RestaurantSubscriptionPricingBenefitId,
};
